<template>
  <div
    class="w-full relative md:overflow-visible"
    :class="[
      { 'mt-10 md:mt-20': content.layout === 'free_100' },
      { 'max-w-screen-md md:mx-auto': !isTwoThird },
      { 'first:mt-0 my-12 sm:mt-14 lg:my-16': isTwoThird },
    ]"
    :data-widget-title="content.optionalTitle?.text"
  >
    <div v-if="isTwoThird" class="shadow-4 px-box-4 pt-8 pb-48 -mb-40 bg-hero md:rounded-t-20">
      <SliceTitle
        class="text-24 sm:text-26 md:text-32 xl:text-34 font-bold text-white text-center"
        :value="content.optionalTitle"
      />
    </div>
    <div class="pt-0.5 shadow-2 rounded-8 bg-white" :class="{ 'mx-box-2': isTwoThird }">
      <SliceTitle
        v-if="!isTwoThird"
        class="sidebar-header text-center subtitle2 text-gray-600 px-4 pt-7 pb-8 m-4"
        :value="content.optionalTitle"
      />
      <TransferSearchForm
        :default-country-from="
          content.defaultCountryFrom?.iso ?? page?.context.countryFrom ?? undefined
        "
        :default-country-to="content.defaultCountryTo?.iso ?? page?.context.countryTo ?? undefined"
        :default-currency-from="String(route.params.currencyFrom)"
        :default-currency-to="String(route.params.currencyTo)"
        :default-amount="defaultAmount"
        :payout="page?.context.payout ?? undefined"
        :sidebar="content.layout === 'boxed_33'"
        :no-overlay="content.layout === 'boxed_33'"
        :cta="content.optionalCtaLabel"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GQLTransferSearchFormSlice } from './generated/transfer-search-form'
import type { GQLPageMeta } from '@core/composables/use-page-meta/generated/page-meta'
import { TransferSearchForm } from '#components'

const props = defineProps<{ content: GQLTransferSearchFormSlice }>()
const page = inject<GQLPageMeta>('pageContext')

const isTwoThird = computed(() => props.content.layout === 'boxed_66')

const route = useRoute()
const defaultAmount = computed(() => {
  return Number(route.params.amount) || Number(page?.context.amount) || 0
})
</script>
